<template>
  <CustomModal v-if="open" @close="$emit('close')" class="invest-modal">
    <template v-slot:body>
      <LeftGradientBlockLayout>
        <LeftGradientBlockLayoutHead>
          <template slot="title">{{ $t('modalTitle') }}</template>
          <template slot="form-menu">
            <RadioTags v-model="deal_type"
                       :options="deal_type_list"
                       name="deal-type"/>
          </template>
        </LeftGradientBlockLayoutHead>
        <ManualDealsForm :deal_type="deal_type" @success="$emit('close')"/>
      </LeftGradientBlockLayout>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import LeftGradientBlockLayout from "@/components/layouts/cabinet/LeftGradientBlockLayout/LeftGradientBlockLayout";
import LeftGradientBlockLayoutHead
  from "@/components/layouts/cabinet/LeftGradientBlockLayout/LeftGradientBlockLayoutHead";
import ManualDealsForm from "@/components/cabinet/Investments/modals/ManualDealsModal/ManualDealsForm";
import RadioTags from "@/components/UI/RadioTags";
import {mapGetters} from "vuex";
import {dealTypes} from "@/utilities/invest_deal_types";

export default {
  name: "ManualIncomesModal",
  components: {
    RadioTags,
    ManualDealsForm,
    LeftGradientBlockLayoutHead,
    LeftGradientBlockLayout,
    CustomModal
  },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      deal_type: null,
      submitted: false,
    }
  },
  computed: {
    deal_type_list() {
      return [
        {value: dealTypes.TYPE_INCOME_DIVIDEND, text: this.$t('dividend'), color: 'green'},
        {value: dealTypes.TYPE_INCOME_COUPON, text: this.$t('coupon'), color: 'green'}
      ]
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.deal_type = dealTypes.TYPE_INCOME_DIVIDEND
      }
    }
  },
  i18n: {
    messages: {
      en: {
        modalTitle: 'Income',
        dividend: 'Dividend',
        coupon: 'Coupon',
      },
      ru: {
        modalTitle: 'Доход',
        dividend: 'Дивиденд',
        coupon: 'Купон',
      }
    }
  }
}
</script>